export default [
  {
    label: 'NATURE_OF_BUSINESS_ARCHITECTURE',
    value: 'Architecture'
  },
  {
    label: 'NATURE_OF_BUSINESS_ART',
    value: 'Art'
  },
  {
    label: 'NATURE_OF_BUSINESS_BEAUTY',
    value: 'Beauty'
  },
  {
    label: 'NATURE_OF_BUSINESS_DIGITAL',
    value: 'Digital'
  },
  {
    label: 'NATURE_OF_BUSINESS_EVENTS',
    value: 'Events'
  },
  {
    label: 'NATURE_OF_BUSINESS_FASHION',
    value: 'Fashion'
  },
  {
    label: 'NATURE_OF_BUSINESS_FILM',
    value: 'Film'
  },
  {
    label: 'NATURE_OF_BUSINESS_FINANCE',
    value: 'Finance'
  },
  {
    label: 'NATURE_OF_BUSINESS_FOOD_AND_BEVERAGE',
    value: 'Food and Beverage'
  },
  {
    label: 'NATURE_OF_BUSINESS_GRAPHIC_DESIGN',
    value: 'Graphic Design'
  },
  {
    label: 'NATURE_OF_BUSINESS_HEALTH_AND_WELLNESS',
    value: 'Health and Wellness'
  },
  {
    label: 'NATURE_OF_BUSINESS_HEALTHCARE',
    value: 'Healthcare'
  },
  {
    label: 'NATURE_OF_BUSINESS_HOSPITALITY',
    value: 'Hospitality'
  },
  {
    label: 'NATURE_OF_BUSINESS_INTERIOR_DESIGN',
    value: 'Interior Design'
  },
  {
    label: 'NATURE_OF_BUSINESS_LAW',
    value: 'Law'
  },
  {
    label: 'NATURE_OF_BUSINESS_MARKETING_ADVERTISING_BRANDING',
    value: 'Marketing/Advertising/Branding'
  },
  {
    label: 'NATURE_OF_BUSINESS_MEDIA_AND_ENTERTAINMENT',
    value: 'Media & Entertainment'
  },
  {
    label: 'NATURE_OF_BUSINESS_MUSIC',
    value: 'Music'
  },
  {
    label: 'NATURE_OF_BUSINESS_PERFORMING_ARTS',
    value: 'Performing Arts'
  },
  {
    label: 'NATURE_OF_BUSINESS_PHILANTHROPY',
    value: 'Philanthropy'
  },
  {
    label: 'NATURE_OF_BUSINESS_PHOTOGRAPHY',
    value: 'Photography'
  },
  {
    label: 'NATURE_OF_BUSINESS_PUBLIC_RELATIONS',
    value: 'Public Relations'
  },
  {
    label: 'NATURE_OF_BUSINESS_PUBLISHING',
    value: 'Publishing'
  },
  {
    label: 'NATURE_OF_BUSINESS_REAL_ESTATE',
    value: 'Real Estate'
  },
  {
    label: 'NATURE_OF_BUSINESS_RETAIL',
    value: 'Retail'
  },
  {
    label: 'NATURE_OF_BUSINESS_TECHNOLOGY',
    value: 'Technology'
  }
]
